<template>
	<div>
		<Modal
			v-if="noticeModal"
			:className="noticeModalData.className"
			:close-on-click-outside="closeOnClickOutside"
			:width="width"
			:title="noticeModalData.title"
			:nextBtnStatus="nextBtnStatus"
			:allow-close="allowClose"
			@close="closeNoticeModal"
		>
			<template slot="body">
				<HasChangesCloseConfirmationModal v-if="noticeModalData.type === 'HasChangesCloseConfirmationModal'"/>
				<ContactModal v-if="noticeModalData.type === 'ContactModal'"/>
				<ReceivableDetailsModal v-if="noticeModalData.type === 'ReceivableDetailsModal'" @ready="onModalContentReady"/>
				<CompanyDetailsModal v-if="noticeModalData.type === 'CompanyDetailsModal'"/>
				<BeneficialOwnerModal v-if="noticeModalData.type === 'BeneficialOwnerModal'"/>
				<RevolvingPutOptionContractDetailsModal v-if="noticeModalData.type === 'RevolvingPutOptionContractDetailsModal'"/>
				<RevolvingPutOptionContractDetailsModal v-if="noticeModalData.type === 'RevolvingPutOptionContractDetailsModal'"/>
			</template>
		</Modal>
	</div>
</template>
<script>
import Modal from "./Modal";
import {mapGetters} from "vuex";
import CompanyDetailsModal from "@/components/templates/modal/CompanyDetailsModal.vue";
import BeneficialOwnerModal from "@/components/templates/kyc/BeneficialOwnerModal.vue";
import ContactModal from "@/components/templates/seller/ContactModal.vue";
import ReceivableDetailsModal from "@/components/templates/seller/sell/ReceivableDetailsModal.vue";
import RevolvingPutOptionContractDetailsModal
	from "@/components/templates/modal/revolvingPutOption/RevolvingPutOptionContractDetailsModal";
import HasChangesCloseConfirmationModal from "@/components/templates/modal/HasChangesCloseConfirmationModal.vue";

export default {
	components: {
		HasChangesCloseConfirmationModal,
		Modal,
		BeneficialOwnerModal,
		CompanyDetailsModal,
		ContactModal,
		ReceivableDetailsModal,
		RevolvingPutOptionContractDetailsModal,
	},
	data() {
		return {
			noticeModal: false,
			nextBtnStatus: true,
			width: 500,
			closeOnClickOutside: true,
			allowClose: true,
		};
	},
	methods: {
		closeNoticeModal() {
			this.noticeModal = false;
			this.$store.dispatch("setActionNoticModal", { show: false, data: {} });
		},
		onModalContentReady(ref) {
			if (ref.adjustedWidth) {
				this.width = ref.adjustedWidth;
			}
		}
	},
	computed: {
		...mapGetters({
			noticeModalData: "noticeModalData",
			noticeModalShow: "noticeModalShow"
		})
	},
	watch: {
		noticeModalShow() {
			this.noticeModal = this.noticeModalShow;
		},
		noticeModalData() {
			let { width, allowClose, closeOnClickOutside } = this.noticeModalData;
			this.width = width ?? 500;
			this.allowClose = allowClose ?? true;
			this.closeOnClickOutside = closeOnClickOutside ?? true;
		}
	}
};
</script>
